import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../components/ui/Button'
import { useLogout } from '../../auth/useLogout'
import { useAssistantAutoPersona } from './useAssistantAutoPersona'
import ProxySwitchingNotice from './ProxySwitchingNotice'
import AssistantPersonaChooser from './AssistantPersonaChooser'
// Bu dosya `.proxy-bootstrap-exit`'i kullanıyor; import ÖRTÜK bağımlılık bırakmamak için burada
// (bugün stil yalnız Chooser'ın import'u sayesinde pakete giriyordu — Chooser bir gün `React.lazy`
// ile ayrılırsa yükleme dalının düğmesi stilsiz kalırdı). CSS import'ları idempotenttir.
import './proxy.css'

/**
 * Kendi profili olmayan asistanı açılışta yöneticinin kipine sokar (126, kullanıcı isteği
 * 21.10.2026). Koşullar ve gerekçeleri {@link useAssistantAutoPersona}'da.
 *
 * <p><b>Neden ayrı bir bileşen:</b> {@code AccessGate}'in tek sorumluluğu İK erişim kapısıdır (099)
 * ve javadoc'u bunu adıyla anlatıyor; persona varsayılanını oraya katmak iki ayrı kararı tek yere
 * yığardı. Sıra önemlidir: erişim kapısı **önce** geçer, sonra persona seçilir — erişimi kısıtlı bir
 * kullanıcı için persona sorusunun anlamı yok.
 *
 * <p>Geçiş sürerken kabuk yerine nötr yükleme gösterilir; aksi hâlde kullanıcı bir an **boş menüyü**
 * görür, sonra ekran sıçrardı. Aynı desen {@code AccessGate}'in kendi yükleme dalında da var.
 *
 * <p><b>HER İKİ dal da kendi ÇIKIŞINI taşımak zorunda</b> (push kapısı review'ü 21.10.2026, iki tur).
 * Bu bileşen {@code AppLayout}'un <i>yerine</i> çiziliyor, yani Topbar ve kimlik menüsü hiç mount
 * edilmiyor — kullanıcının başka hiçbir çıkışı yok. İlk düzeltme yalnız seçim ekranına düğme koydu ve
 * <b>yükleme dalı atlandı</b>; ölçüldü: {@code activateProxyPersona} POST'u <b>askıda kalırsa</b>
 * ({@code src/api} katmanında timeout YOK) {@code .finally} hiç tetiklenmez, spinner sonsuza kadar
 * durur ve <b>sayfayı yenilemek kurtarmaz</b> — hook bilinçle her yüklenişte yeniden deniyor ve çerez
 * yazılmadığı için koşullar aynı kalıyor. Projedeki diğer bütün kabuksuz ekranların bir aksiyonu var
 * ({@code AccessRestrictedPage} → Çıkış, {@code AuthLoading}/{@code ErrorBoundary} → Tekrar dene).
 */
export default function AssistantPersonaBootstrap({ children }: { children: ReactNode }) {
  const { t } = useTranslation()
  const logout = useLogout()
  const state = useAssistantAutoPersona()
  if (state.kind === 'entering') {
    return (
      <>
        {/* Gösterge ORTAKTIR: `AppLayout`'un persona geçişi de aynısını kullanıyor. Çıkış düğmesi
            ONUN İÇİNE konmadı — AppLayout'ta Topbar zaten var ve orada ikinci bir Çıkış istenmez. */}
        <ProxySwitchingNotice />
        <div className="proxy-bootstrap-exit">
          <Button label={t('auth.logout')} icon="pi pi-sign-out" text onClick={logout} />
        </div>
      </>
    )
  }
  // Birden çok yönetici: tahmin etmek yerine SORULUR. Kabuk çizilmez — çizilseydi kullanıcı yine
  // boş bir uygulamaya bakardı, ki bu ekranın var oluş sebebi tam olarak o.
  if (state.kind === 'choose') return <AssistantPersonaChooser personas={state.personas} />
  return <>{children}</>
}
